import { Query } from 'upstream-shared/models';
import { upstreamApi } from '../upstreamApi';
import { asyncAction } from './asyncAction';
import { READ_SERVER } from './actionTypes';

export function readTransfers(storeIdentifier: string, query: Query) {
  query.q = query.q || '*';
  query.skip = query.skip || 0;
  query.limit = query.limit || 25;
  query.filters = query.filters || {};

  return asyncAction({
    actionType: READ_SERVER,
    func: async () => (await upstreamApi.transfers.search(query)).data,
    storeIdentifier,
    requestPayload: { query },
  });
}

export function exportTransfers(storeIdentifier: string, query: Query, units: string, localDatetime: string) {
  query.q = query.q || '*';
  query.filters = query.filters || {};

  return asyncAction({
    actionType: READ_SERVER,
    func: async () => (await upstreamApi.transfers.searchExport(query, units, localDatetime)).data,
    storeIdentifier,
    requestPayload: { query },
  });
}
